var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelledCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 490.299,
    height: 340.099,
    viewBox: "0 0 490.299 340.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff1ea;}.b{fill:#f9d283;}.c{fill:#e8a058;}.d{fill:#242833;}.e{fill:#9dacef;}.f{fill:#4a55a7;}.g{fill:#c0ceff;}.h{fill:#8495d3;}.i,.p{fill:#fff;}.j{clip-path:url(#a);}.k{fill:#F87847;}.l{fill:#bf5f21;}.m{fill:#ebf6ff;opacity:0.43;}.n{fill:#e6e6e6;}.o{fill:$billsby-black;}.p{opacity:0.3;}.q{fill:none;stroke:#242833;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.317,100.11H244L230.21,265H468.075L481.862,100.11Z",
    transform: "translate(-230.21 -100.11)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.72 -48.465)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M485.348,388.557H87.57S7.036,333.781,47.795,247.707C75.837,196.192,126.044,172.719,143,116.965S256.462,31.869,330.15,58.28c47.6,19.881,37.5,93.568,97.49,134.327s84.443,54.123,90.643,102.706S485.348,388.557,485.348,388.557Z",
    transform: "translate(-3.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.795,347.506C7.036,433.579,87.57,488.356,87.57,488.356H485.348s39.128-44.668,32.928-93.251c-3-23.506-10.267-38.765-23.77-52.875H50.8Q49.264,344.825,47.795,347.506Z",
    transform: "translate(-3.927 -99.799)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.637 242.438)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44.058,446.506c.244.64.5,1.274.746,1.9,14.183-7.534,21.835-16.342,22.78-26.305.832-8.755-1.274-16.19-6.266-22.093-5.956-7.045-14.731-10.465-21.142-12.109-.152.66-.3,1.314-.436,1.968,6.147,1.591,14.513,4.853,20.066,11.423,4.635,5.48,6.59,12.42,5.8,20.627C64.626,432.231,55.613,440.313,44.058,446.506Z",
    transform: "translate(-39.74 -357.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M231.88,461.211c-9.363-9.8-23.308-14.539-41.452-14.11-54.592,1.314-58.705-5.87-75.985-36.1-2.5-4.378-5.335-9.33-8.617-14.77-13.542-22.443-33.053-28.458-47.038-29.554a73.552,73.552,0,0,0-12.492.106c-.258.693-.5,1.387-.746,2.08a71.8,71.8,0,0,1,13.08-.211c19.663,1.538,34.975,11.165,45.493,28.6,3.268,5.421,6.094,10.366,8.59,14.731,16.15,28.247,21.274,37.233,67.124,37.233q4.982,0,10.624-.139c17.557-.423,31.013,4.12,39.973,13.5,8.432,8.828,12.327,21.023,13.912,34.011h1.994C244.749,483.152,240.728,470.468,231.88,461.211Z",
    transform: "translate(-41.714 -350.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M138.173,542.035A201.04,201.04,0,0,0,96.8,546.9c.614.568,1.208,1.109,1.789,1.631a199.076,199.076,0,0,1,39.61-4.516c17.359-.185,39.894,2.166,60.838,12.222h4.391C181.177,544.518,156.747,541.851,138.173,542.035Z",
    transform: "translate(-59.125 -410.112)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M648.837,500.638c-17.946,13.3-33.687,26.041-44.747,35.285h3.09c10.908-9.072,25.883-21.135,42.832-33.694,22.311-16.533,43.334-19.736,56.553-17.312q.307-.941.594-1.9C693.492,480.44,671.768,483.649,648.837,500.638Z",
    transform: "translate(-231.462 -389.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M683.412,359.671a102.9,102.9,0,0,0,42.568,13.74c-.231-.7-.469-1.38-.713-2.067a100.976,100.976,0,0,1-40.772-13.338,96.041,96.041,0,0,1-20.2-15.767H661.57A95.132,95.132,0,0,0,683.412,359.671Z",
    transform: "translate(-250.99 -342.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M605.233,477.47c-27.573,21.406-47.943,35.833-66.563,45.48h4.272c17.814-9.68,37.471-23.7,63.5-43.915a159.484,159.484,0,0,1,82.977-32.974c.04-.667.079-1.334.106-2A161.557,161.557,0,0,0,605.233,477.47Z",
    transform: "translate(-209.238 -376.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M548.646,466.47q4.823-3.605,10.049-7.507c27.85-20.759,57.9-28.649,78.2-31.614a185.014,185.014,0,0,1,25.388-1.948c-.059-.66-.132-1.321-.211-1.981a186.42,186.42,0,0,0-25.394,1.954c-20.548,2.991-50.96,10.974-79.167,32q-5.239,3.912-10.056,7.514c-36.672,27.435-56.394,42.192-88.127,51.053h6.953C494.694,506.839,514.265,492.195,548.646,466.47Z",
    transform: "translate(-182.284 -369.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M170.9,353.98H51.542q-.446.99-.872,1.981H170.9Z",
    transform: "translate(-43.453 -346.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M504.449,458.526c-28.841,14.969-61.63,12.73-61.954,12.7l-.145,1.974c.079.007,1.968.139,5.2.139,10.545,0,35.345-1.393,57.82-13.06,10.716-5.56,17.015-12.235,18.732-19.828a20.244,20.244,0,0,0-3.169-15.715l-1.578,1.2a18.541,18.541,0,0,1,2.806,14.11C520.566,447.038,514.611,453.251,504.449,458.526Z",
    transform: "translate(-176.516 -370.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M663.756,376.517c0-3.361-6.253-5.117-12.433-5.117s-12.433,1.756-12.433,5.117,6.253,5.124,12.433,5.124S663.756,379.878,663.756,376.517Zm-22.879,0c0-1.281,4.074-3.136,10.452-3.136s10.452,1.862,10.452,3.136-4.074,3.143-10.452,3.143S640.877,377.8,640.877,376.517Z",
    transform: "translate(-243.285 -352.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M694.909,409.44H560.16v1.981H695.273C695.154,410.754,695.035,410.094,694.909,409.44Z",
    transform: "translate(-216.538 -365.069)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M425.373,93.91H406.945a2.243,2.243,0,0,1-2.245-2.245h0a2.243,2.243,0,0,1,2.245-2.245h18.428a2.243,2.243,0,0,1,2.245,2.245h0A2.243,2.243,0,0,1,425.373,93.91Z",
    transform: "translate(-129.088 -13.913)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.72 72.199)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M211.94,287.327H482.271L499.339,84.41H229.008Z",
    transform: "translate(-88.323 -84.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M462.317,100.11H244L230.21,265H468.075L481.862,100.11Z",
    transform: "translate(-94.53 -89.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M417.2,373.513,552.167,288.02l16.9-203.61H555.878L542.052,278.842,417.2,359.052Z",
    transform: "translate(-158.054 -84.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M149.572,378.88,24.72,459.091H283.866L408.718,378.88Z",
    transform: "translate(-24.72 -184.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M227.542,453.5l-34.632,18.56v2.7h66.642L294.183,453.5v-2.7Z",
    transform: "translate(-81.858 -208.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M151.011,433.254,142.46,436.8v1.7h16.448l8.551-5.249V431.61Z",
    transform: "translate(-64.719 -202.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M187.011,433.254,178.46,436.8v1.7h16.448l8.551-5.249V431.61Z",
    transform: "translate(-76.949 -202.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M230.051,433.334,221.5,436.88v1.7h16.448l8.544-5.249V431.69Z",
    transform: "translate(-91.571 -202.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M253.411,433.334l-8.551,3.546v1.7h16.447l8.551-5.249V431.69Z",
    transform: "translate(-99.507 -202.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M276.774,433.334l-8.544,3.546v1.7h16.441l8.551-5.249V431.69Z",
    transform: "translate(-107.446 -202.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M300.134,433.334l-8.544,3.546v1.7h16.448l8.544-5.249V431.69Z",
    transform: "translate(-115.382 -202.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M323.494,433.334l-8.544,3.546v1.7H331.4l8.544-5.249V431.69Z",
    transform: "translate(-123.318 -202.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M346.854,433.334l-8.544,3.546v1.7h16.448l8.544-5.249V431.69Z",
    transform: "translate(-131.254 -202.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M370.221,433.334l-8.551,3.546v1.7h16.448l8.544-5.249V431.69Z",
    transform: "translate(-139.189 -202.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M386.871,433.334l-8.551,3.546v1.7h16.448l8.551-5.249V431.69Z",
    transform: "translate(-144.846 -202.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M173.224,419.441l-8.544,3.539v1.7h16.448l8.544-5.243V417.79Z",
    transform: "translate(-72.268 -197.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M209.2,419.441l-8.544,3.546v1.7h16.448l8.544-5.243V417.79Z",
    transform: "translate(-84.491 -197.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M191.734,406.131l-8.544,3.546v1.7h16.448l8.544-5.243V404.48Z",
    transform: "translate(-78.556 -193.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M227.954,406.131l-8.544,3.546v1.7h16.448l8.544-5.243V404.48Z",
    transform: "translate(-90.861 -193.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M245.691,419.424l-8.551,3.546v1.7h16.448l8.551-5.249V417.78Z",
    transform: "translate(-96.884 -197.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M281.691,419.414l-8.551,3.546v1.7h16.448l8.551-5.249V417.77Z",
    transform: "translate(-109.114 -197.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M264.441,406.131l-8.551,3.546v1.7h16.448l8.551-5.243V404.48Z",
    transform: "translate(-103.254 -193.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M300.414,406.111l-8.544,3.546v1.7h16.448l8.544-5.243V404.46Z",
    transform: "translate(-115.477 -193.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M318.144,419.424,309.6,422.97v1.7h16.448l8.544-5.249V417.78Z",
    transform: "translate(-121.5 -197.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M354.124,419.4l-8.544,3.546v1.7h16.448l8.544-5.249V417.75Z",
    transform: "translate(-133.723 -197.653)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M336.9,406.1l-8.551,3.546v1.7H344.8l8.551-5.243V404.45Z",
    transform: "translate(-127.87 -193.135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M372.884,406.131l-8.544,3.546v1.7h16.448l8.544-5.243V404.48Z",
    transform: "translate(-140.097 -193.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M390.611,419.414l-8.551,3.546v1.7h16.448l8.544-5.249V417.77Z",
    transform: "translate(-146.116 -197.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M426.584,419.454,418.04,423v1.7h16.448l8.544-5.249V417.81Z",
    transform: "translate(-158.34 -197.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M409.374,406.131l-8.544,3.546v1.7h16.441l8.551-5.243V404.48Z",
    transform: "translate(-152.493 -193.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M445.344,406.161l-8.544,3.546v1.7h16.448l8.544-5.249V404.51Z",
    transform: "translate(-164.713 -193.155)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M463.071,419.4l-8.551,3.546v1.7h16.448l8.544-5.249V417.75Z",
    transform: "translate(-170.733 -197.653)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M429.941,433.314l-8.551,3.546v1.7h16.448l8.551-5.249V431.67Z",
    transform: "translate(-159.478 -202.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M465.814,433.381l-8.544,3.546v1.7h16.448l8.544-5.243V431.73Z",
    transform: "translate(-171.667 -202.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M499.054,419.341l-8.544,3.546v1.7h16.448l8.544-5.249V417.69Z",
    transform: "translate(-182.959 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M481.094,405.791l-8.544,3.546v1.7H489l8.544-5.243V404.14Z",
    transform: "translate(-176.858 -193.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M517.8,406.093l-8.544,3.546v1.7h16.448l8.544-5.243.007-1.723Z",
    transform: "translate(-189.329 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M227.542,450.8,192.91,472.061h66.642L294.183,450.8Z",
    transform: "translate(-81.858 -208.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M150.971,431.61l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-64.705 -202.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M186.951,431.61l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-76.929 -202.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M173.231,417.69l-8.551,5.249h16.454l8.557-5.249Z",
    transform: "translate(-72.268 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M209.211,417.69l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-84.491 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M245.691,417.69l-8.551,5.249H253.6l8.551-5.249Z",
    transform: "translate(-96.884 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M281.671,417.69l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-109.107 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M318.151,417.69l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-121.5 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M354.131,417.69l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-133.723 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M390.611,417.69l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-146.116 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M426.591,417.69l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-158.34 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M463.071,417.69l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-170.733 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M499.051,417.69l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-182.956 -197.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M191.981,404.37l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-78.637 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M227.961,404.37l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-90.861 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M264.441,404.37l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-103.254 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M300.421,404.37l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-115.477 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M336.9,404.37l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-127.87 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M372.881,404.37l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-140.093 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M409.361,404.37l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-152.486 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M445.341,404.37l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-164.709 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M481.827,404.37l-8.557,5.249h16.461l8.551-5.249Z",
    transform: "translate(-177.103 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M517.8,404.37l-8.551,5.249H525.7l8.551-5.249Z",
    transform: "translate(-189.326 -193.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M211.474,392.681l-8.544,3.546v1.7h16.441l8.551-5.249V391.03Z",
    transform: "translate(-85.262 -188.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M247.694,392.681l-8.544,3.546v1.7H255.6l8.544-5.249V391.03Z",
    transform: "translate(-97.567 -188.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M284.174,392.681l-8.544,3.546v1.7h16.448l8.544-5.249V391.03Z",
    transform: "translate(-109.96 -188.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M320.154,392.681l-8.544,3.546v1.7h16.448l8.544-5.249V391.03Z",
    transform: "translate(-122.183 -188.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M356.641,392.681l-8.551,3.546v1.7h16.448l8.544-5.249V391.03Z",
    transform: "translate(-134.576 -188.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M392.624,392.681l-8.544,3.546v1.7h16.448l8.544-5.249V391.03Z",
    transform: "translate(-146.803 -188.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M429.111,392.681l-8.551,3.546v1.7h16.448l8.551-5.249V391.03Z",
    transform: "translate(-159.196 -188.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M465.084,392.7l-8.544,3.546v1.7h16.448l8.544-5.249V391.06Z",
    transform: "translate(-171.419 -188.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M501.571,392.574l-8.551,3.546v1.7h16.448l8.551-5.249V390.93Z",
    transform: "translate(-183.812 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M537.544,392.574,529,396.12v1.7h16.448l8.544-5.249V390.93Z",
    transform: "translate(-196.035 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M211.721,390.93l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-85.343 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M247.7,390.93l-8.551,5.249H255.6l8.551-5.249Z",
    transform: "translate(-97.567 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M284.181,390.93l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-109.96 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M320.161,390.93l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-122.183 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M356.641,390.93l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-134.576 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M392.621,390.93l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-146.799 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M429.1,390.93l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-159.192 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M465.081,390.93l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-171.416 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M501.561,390.93l-8.551,5.249h16.461l8.551-5.249Z",
    transform: "translate(-183.809 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M537.541,390.93l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-196.032 -188.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M429.957,431.61l-8.557,5.249h16.461l8.551-5.249Z",
    transform: "translate(-159.481 -202.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M465.931,431.61l-8.551,5.249h16.454l8.551-5.249Z",
    transform: "translate(-171.704 -202.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M335.253,431.61h-105.2l-8.551,5.249H341.492l8.551-5.249Z",
    transform: "translate(-91.571 -202.362)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 259.146,
    height: 14.46,
    transform: "translate(0 274.642)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 5.718,
    cy: 5.718,
    r: 5.718,
    transform: "translate(239.17 184.699) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.4 82.565)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.432 8.707)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.486) rotate(-4.012)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 59.167,
    height: 6.306,
    transform: "translate(95.945 99.461) rotate(155.939)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.168,14.736a8.469,8.469,0,1,1,.568-11.964A8.468,8.468,0,0,1,14.168,14.736Z",
    transform: "translate(25.117 114.941)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 6.306,
    height: 85.988,
    transform: "matrix(-0.993, 0.114, -0.114, -0.993, 32.846, 123.517)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 61.386,
    height: 2.1,
    transform: "translate(90.578 91.659) rotate(155.021)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 2.1,
    height: 81.795,
    transform: "matrix(-0.982, 0.19, -0.19, -0.982, 39.592, 119.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M81.406,35.695l-63.34-4.959c-5.48-.429-10.076-3.46-11.231-7.4L0,0,104.694,8.194l-11.119,22.1C91.752,33.919,86.8,36.111,81.406,35.695Z",
    transform: "translate(93.316 103.939)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M181.781,98.274,0,84.052a91.167,91.167,0,0,1,182,10.34C181.959,95.679,181.88,96.98,181.781,98.274Z",
    transform: "translate(56.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M37.874,84.932C44.648,14.222,0,0,0,0A91.188,91.188,0,0,1,72.69,92.531Z",
    transform: "translate(165.399 1.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M192.879,20.712,191.2,42.2a6.229,6.229,0,0,1-6.689,5.738h-.013l-76.7-6L5.75,33.944a6.234,6.234,0,0,1-5.731-6.7v-.007L1.7,5.756A6.229,6.229,0,0,1,8.391.019H8.4L118.723,8.662l68.431,5.355A6.224,6.224,0,0,1,192.879,20.712Z",
    transform: "translate(49.97 75.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M85.083,12.05,83.4,33.536a6.229,6.229,0,0,1-6.689,5.738H76.7l-76.7-6C12.981,22.542,10.994.6,10.934,0L79.365,5.355A6.228,6.228,0,0,1,85.083,12.05Z",
    transform: "translate(157.766 84.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M38.23.107h0A34.662,34.662,0,0,1,70.082,37.373l-.964,12.314h0L0,44.28H0L.964,31.966A34.667,34.667,0,0,1,38.23.107Z",
    transform: "translate(92.854 33.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M23.233,13.723a1.049,1.049,0,0,1-1.017-.9c-.059-.4-1.472-10.082-9.3-10.69C5.035,1.521,2.09,11.141,2.057,11.24a1.051,1.051,0,1,1-2.014-.6A19.906,19.906,0,0,1,2.883,5.132,11.059,11.059,0,0,1,22.361,6.651a19.966,19.966,0,0,1,1.948,5.883,1.054,1.054,0,0,1-.891,1.188h-.185Z",
    transform: "translate(100.397 52.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M23.217,13.718a1.049,1.049,0,0,1-1.017-.9c-.059-.4-1.472-10.082-9.3-10.69S2.167,10.833,2.042,11.235a1.055,1.055,0,0,1-1.334.654,1.045,1.045,0,0,1-.674-1.255A19.813,19.813,0,0,1,2.874,5.128,11.062,11.062,0,0,1,22.352,6.653,19.968,19.968,0,0,1,24.3,12.536a1.055,1.055,0,0,1-.891,1.189H23.4A1.571,1.571,0,0,1,23.217,13.718Z",
    transform: "translate(132.832 55.392)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.221 113.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 1.05,
    height: 21.314,
    transform: "matrix(-0.992, 0.124, -0.124, -0.992, 3.693, 21.148)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 1.05,
    height: 21.135,
    transform: "matrix(-0.997, 0.077, -0.077, -0.997, 14.72, 22.058)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 1.05,
    height: 20.924,
    transform: "translate(25.343 22.94) rotate(-179.358)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 21.314,
    height: 1.05,
    transform: "translate(74.584 5.984) rotate(106.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M0,20.561l1.023.244L5.916.244,4.893,0Z",
    transform: "translate(56.616 4.758)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 20.878,
    height: 1.05,
    transform: "translate(37.819 2.977) rotate(94.508)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 20.951,
    height: 1.05,
    transform: "translate(51.349 4.087) rotate(99.451)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M13.7,0A13.429,13.429,0,1,1,0,13.162,13.43,13.43,0,0,1,13.7,0Z",
    transform: "translate(207.865 93.115)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 4.199,
    height: 59.161,
    transform: "translate(258.365 166.649) rotate(151.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.638,0A8.47,8.47,0,1,1,0,8.3,8.472,8.472,0,0,1,8.638,0Z",
    transform: "translate(247.146 165.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 85.922,
    height: 4.199,
    transform: "matrix(-0.6, 0.8, -0.8, -0.6, 261.936, 176.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M.65,7.44a3.148,3.148,0,0,1,.588-4.417,3.212,3.212,0,0,1,1.426-.614l15.1-2.37a3.148,3.148,0,0,1,.977,6.22h0L3.641,8.636A3.168,3.168,0,0,1,.65,7.44Z",
    transform: "translate(185.792 240.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M20.9,1.545l1.043.654A10.1,10.1,0,0,1,25.817,14.81L19.729,28.65,0,13.4,7.62,3.81A10.111,10.111,0,0,1,20.9,1.545Z",
    transform: "translate(190.542 240.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3.084,19.577A3.149,3.149,0,0,1,.417,14.863L8,1.591a3.151,3.151,0,0,1,5.474,3.123L5.891,17.986A3.142,3.142,0,0,1,3.084,19.577Z",
    transform: "translate(182.869 251.287)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3.084,20.458A3.151,3.151,0,0,1,0,17.236,3.231,3.231,0,0,1,.331,15.9L7.35,1.812a3.152,3.152,0,1,1,5.7,2.681c-.02.04-.04.086-.059.125L5.976,18.709A3.155,3.155,0,0,1,3.084,20.458Z",
    transform: "translate(190.422 255.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3.078,14.674a3.152,3.152,0,0,1-2.72-4.609L4.7,1.719a3.151,3.151,0,1,1,5.612,2.866l-.02.04L5.95,12.971A3.152,3.152,0,0,1,3.078,14.674Z",
    transform: "translate(200.578 261.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M17.656,22.932l-1.208.231A10.1,10.1,0,0,1,5,16.593L0,2.324,24.826,0l.984,12.209A10.114,10.114,0,0,1,17.656,22.932Z",
    transform: "translate(2.957 19.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1.511.457A3.158,3.158,0,0,1,6.3,3.006l.713,15.272a3.15,3.15,0,0,1-6.292.3h0L.005,3.3A3.119,3.119,0,0,1,1.511.457Z",
    transform: "translate(20.813 3.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M11.2,0a3.157,3.157,0,0,1,3,3.295,3.2,3.2,0,0,1-.449,1.486L5.842,17.857A3.149,3.149,0,0,1,.454,14.6h0L8.364,1.522A3.136,3.136,0,0,1,11.2,0Z",
    transform: "translate(22.279 19.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1.237.648a3.156,3.156,0,0,1,5,1.842l3.3,15.391a3.155,3.155,0,0,1-6.167,1.327L.068,3.817A3.175,3.175,0,0,1,1.237.648Z",
    transform: "translate(9.849 4.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M.95.894a3.161,3.161,0,0,1,5.2,1.274l2.932,8.94a3.154,3.154,0,0,1-6,1.961L.158,4.13A3.15,3.15,0,0,1,.95.894Z",
    transform: "translate(0 9.411)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 2.1,
    height: 61.577,
    transform: "translate(251.611 171.582) rotate(151.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 81.795,
    height: 2.1,
    transform: "translate(252.199 172.696) rotate(122.487)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "o",
    cx: 18.382,
    cy: 26.332,
    rx: 18.382,
    ry: 26.332,
    transform: "translate(214.597 55.788) rotate(-6.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M570.841,232.508l-4.424-.568a54.809,54.809,0,0,1-37.207,41.6l1.459,4.259A59.514,59.514,0,0,0,570.841,232.508Z",
    transform: "translate(-331.787 -144.896)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M517.8,299.864a5.217,5.217,0,1,0,3.915-6.253A5.218,5.218,0,0,0,517.8,299.864Z",
    transform: "translate(-327.867 -165.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M544.321,160.287c-9.865-85.823-79.973-45.4-79.973-45.4-5.553,2.417-9.944,6.042-13.278,7.818,81.307-9.336,82.759,34.526,82.759,34.526",
    transform: "translate(-305.241 -101.899)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 60.567,
    height: 2.1,
    transform: "translate(214.727 51.921) rotate(-89.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M555.711,79.308a3.6,3.6,0,1,1-3.414,3.77A3.6,3.6,0,0,1,555.711,79.308Z",
    transform: "translate(-339.629 -93.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M554.31,173.51h0a5.478,5.478,0,0,1,5.434,5.52l-.033,3.8h0l-10.961-.086h0l.033-3.8A5.484,5.484,0,0,1,554.31,173.51Z",
    transform: "translate(-338.425 -125.046)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.896 82.565)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M241.68,174.424l90.663-74.314H306.876L243.5,152.615Z",
    transform: "translate(-236.602 -100.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M398.716,100.11h-36.19L236.558,204.473,233.99,235.13Z",
    transform: "translate(-233.99 -100.11)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M325.5,155.18s5.157,7.455,2.12,16.388",
    transform: "translate(-102.182 -36.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M333.06,144.3s9.013,13.027,3.711,28.643",
    transform: "translate(-104.75 -32.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M261.077,178.46s-1.089,9,5.758,15.49",
    transform: "translate(-80.274 -44.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M249.293,172.35s-1.9,15.728,10.063,27.071",
    transform: "translate(-76.255 -42.087)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledCompany);
export default __webpack_public_path__ + "static/media/cancelled-company.b81a46d547353b9a06746f55c95ba125.svg";
export { ForwardRef as ReactComponent };